import React from 'react';
import { CalendarReportsProvider } from '../context/CalendarReportsProvider';
import ReportsContainer from '../container/ReportsContainer';

export default function Reports(props) {  
    return (  
        <>         
        <div className="sidebar-bottomcontent-container">
            <div className="sidebar-bottomcontent-container-row">
                <CalendarReportsProvider onLogoutClick={props.onLogoutClick}
                    setSelectedNavItem={props.setSelectedNavItem} isLogout={props.isLogout}
                    setLogoutFalse={props.setLogoutFalse} clearSessionData={props.clearSessionData}>
                        <ReportsContainer isLogout={props.isLogout}   
                                          onLogoutClick={props.onLogoutClick}
                                          clearSessionData={props.clearSessionData} />
                </CalendarReportsProvider>             
            </div> 
        </div>
        </>            
    )
}